<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Addition Of Manpower
    </div>
    <div class="card-body">
        <form (ngSubmit)="Validate(FilterForm)" #FilterForm="ngForm" name="FilterForm" novalidate>
            <div class="row py-1">
                <div class="col-md-3">
                    <label class="Label">Work Order Date<span class="text-danger"
                            *ngIf="(Filter.WorkOrderNumber != null && Filter.WorkOrderNumber != '')">*</span></label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="WorkOrderDate"
                            [(ngModel)]="Filter.WorkOrderDate" ngbDatepicker #WorkOrderDate="ngbDatepicker" readonly
                            [required]="(Filter.WorkOrderNumber != null && Filter.WorkOrderNumber != '')"
                            [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O'" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="WorkOrderDate.toggle()"
                            type="button"
                            [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O'"></button>
                        <div class="invalid-feedback">
                            Please enter work order date.
                        </div>
                    </div>
                    <div class="invalid-feedback">
                        Please select work order date!
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="Label">Work Order No.</label>
                    <input name="workorderno" [(ngModel)]="Filter.WorkOrderNumber" type="text" class="form-control"
                        [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O'" />
                </div>
                <div class="col-md-2" *ngIf="Filter.ESS_ShiftWiseManpowerMasterId > 0">
                    <label class="Label">Entry No.</label>
                    <input name="entryNo" type="text" [(ngModel)]="Filter.EntryNo" class="form-control" disabled />
                </div>
                <div class="col-md-2">
                    <label class="Label2">Current Manpower</label>
                    <input name="total manpower" class="text-right" [(ngModel)]="Filter.TotalManpower" type="text"
                        class="form-control" disabled />
                </div>
                <div class="col-md-auto align-self-end">
                    <button type="button" class="btn btn-primary" name="history" (click)="OpenDesignationSummary()"
                    [disabled]="this.Filter.AllocationType == 'O'">
                        <i class="bi bi-hourglass-split" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'History':'Loading...'}}
                    </button>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-3">
                    <label class="Label">Branch<span class="text-danger">*</span></label>
                    <ng-select [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                        placeholder="Select Branch" [(ngModel)]="Filter.BranchID" name="Branch"
                        (change)="ComboLoad('Client')" required
                        [disabled]="Filter.ESS_ShiftWiseManpowerMasterId>0 || this.Filter.FromPageType == 's' || this.Filter.AllocationType == 'O'">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select branch.
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="Label">Client<span class="text-danger">*</span></label>
                    <ng-select [items]="Clients" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                        placeholder="Select Client" [(ngModel)]="Filter.ClientID" name="Client"
                        (change)="ComboLoad('Site')" required
                        [disabled]="Filter.ESS_ShiftWiseManpowerMasterId>0 || this.Filter.FromPageType == 's' || this.Filter.AllocationType == 'O'">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select client.
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="Label">Site<span class="text-danger">*</span></label>
                    <ng-select [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID" placeholder="Select Site"
                        [(ngModel)]="Filter.SiteID" name="Site" (change)="SelectDate('RegistrationDate', null, null)"
                        required [disabled]="Filter.ESS_ShiftWiseManpowerMasterId>0||this.Filter.FromPageType == 's' || this.Filter.AllocationType == 'O'">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select site.
                    </div>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-3">
                    <label class="Label">Attachment</label>
                    <div class="file-input-container">
                        <input *ngIf="this.Filter.Filename == null" class="form-control form-control-sm" id="formFileSm"
                            type="file" accept=".pdf" (change)="onFileSelected($event)"
                            [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O'" />
                        <span *ngIf="this.Filter.Filename != null" class="file-name">{{ SplitName() }}</span>
                        <span *ngIf="this.Filter.Filename != null"> <button type="button" class="btn btn-sm" name="view"
                                style="color: blue;" (click)="viewFile()"><i class="bi bi-eye"></i></button></span>
                        <button type="button" class="btn btn-sm" *ngIf="this.Filter.Filename != null"
                            [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction)  || this.Filter.AllocationType == 'O'"
                            (click)="removeFile()">
                            <i class="bi bi-trash"></i>
                        </button>
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="Label">Allocation Type</label>
                    <input name="addition" [(ngModel)]="Filter.AllocationTypes" type="text" class="form-control"
                        disabled />
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-3">
                    <label class="Label">Designation<span class="text-danger">*</span></label>
                    <ng-select [items]="Designations" bindLabel="DesignationName" bindValue="DesignationMasterID"
                        placeholder="Select Designation" [(ngModel)]="Filter.DesignationID" name="Designation" required
                        [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O'">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select designation.
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="Label">Duty<span class="text-danger">*</span></label>
                    <ng-select [items]="Dutys" bindLabel="DutyName" bindValue="DutyMasterID" placeholder="Select Duty"
                        [(ngModel)]="Filter.DutyID" name="Duty"
                        [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O'" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select duty.
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="Label">Shift<span class="text-danger">*</span></label>
                    <ng-select [items]="Shifts" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                        placeholder="Select Shift" [(ngModel)]="Filter.ShiftID" name="Shift"
                        [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O'" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select shift.
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="Label">No Of Manpower <span class="text-danger">*</span></label>
                    <input type="text" class="form-control text-end " id="NoOfManpower" name="NoOfManpower"
                        [(ngModel)]="Filter.NoOfManpower" #NoOfManpower="ngModel" pattern="^[0-9]\d*$"
                        (keypress)="common.NumberOnly($event)" minlength="1" maxlength="6"
                        [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O'" required>
                    <div class="invalid-feedback">
                        Please enter no of manpower.
                    </div>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-3">
                    <label class="Label">From Date<span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="FromDate"
                            [(ngModel)]="Filter.FromDate" ngbDatepicker #FromDate="ngbDatepicker" readonly required
                            [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction)  || this.Filter.AllocationType == 'O'" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                            type="button"></button>
                        <div class="invalid-feedback">
                            Please select from date.
                        </div>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="Label">To Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="ToDate" [(ngModel)]="Filter.ToDate"
                            ngbDatepicker #ToDate="ngbDatepicker" (ngModelChange)="SetEffectiveDate()"
                            [disabled]="(this.Filter.ESS_ShiftWiseManpowerMasterId > 0 && this.Filter.EditIndex != null && this.Filter.EntryNo > 0 && (this.AddManpowers[this.Filter.EditIndex].ToDate == null || this.AddManpowers[this.Filter.EditIndex].ToDate == '')) || (Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O'" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                            type="button" [disabled]="(this.Filter.ESS_ShiftWiseManpowerMasterId > 0 && this.Filter.EditIndex != null && this.Filter.EntryNo > 0 && (this.AddManpowers[this.Filter.EditIndex].ToDate == null || this.AddManpowers[this.Filter.EditIndex].ToDate == '')) || (Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O'" ></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select to date!
                    </div>
                </div>
                <div class="col-md-2">
                    <label class="Label">Effective Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="EffectiveDate"
                            [(ngModel)]="Filter.EffectiveDate" ngbDatepicker #EffectiveDate="ngbDatepicker" readonly
                            disabled />
                    </div>
                    <div class="invalid-feedback">
                        Please select effective date!
                    </div>
                </div>
                <div class="col-md">
                    <label class="Label">Remark</label>
                    <textarea name="Remark" [(ngModel)]="Filter.Remark" class="form-control" rows="1" cols="50"
                        style="resize: none;"
                        [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O'"></textarea>
                </div>
                <div class="col-md-auto align-self-end">
                    <button class="btn btn-primary" name="add"
                        [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O'">
                        <i class="bi bi-plus" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        <!-- {{!isDisabled?'Add':'Loading...'}} -->
                        {{ isDisabled ? 'Loading...' : (this.Filter.EditIndex != null ? 'Update' : 'Add') }}
                    </button>
                </div>
            </div>
        </form>

        <div class="card border-radius-0 mt-1 p-0">
            <div class="card-body p-1" style="overflow: auto;">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <!-- <th scope="col" *ngIf="this.Filter.ESS_ShiftWiseManpowerMasterId > 0">Entry No</th> -->
                            <th scope="col">Designation Name</th>
                            <th scope="col">Duty Name</th>
                            <th scope="col">Shift Name</th>
                            <th scope="col">From Date</th>
                            <th scope="col">To Date</th>
                            <th scope="col">Effective Date</th>
                            <th scope="col">No of Employees</th>
                            <th scope="col">Remarks</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let element of AddManpowers; let i = index">
                            <th scope="row">{{ i + 1 }}</th>
                            <!-- <td *ngIf="this.Filter.ESS_ShiftWiseManpowerMasterId > 0">{{element.EntryNo}}</td> -->
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{element.DesignationName}}
                            </td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{element.DutyName}}</td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{element.ShiftTitle}}</td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{element.FromDate}}</td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{element.ToDate}}</td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">
                                {{element.ReductionEffectiveAfter}}</td>
                            <td class="text-end" [ngClass]="{'highlight-row': element.IsMonthLocked == 1}"><span
                                    class="no-of-person">{{element.NoOfPerson}}</span></td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{element.Remarks}}</td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">
                                <button class="btn btn-sm btn-group-toggle"
                                    [ngClass]="{'colHide': element.IsMonthLocked == 1 || Filter.IsAutoReduction || this.Filter.AllocationType == 'O'}"
                                    style="height: 50%; border: none;" (click)="onEditClick(i)">
                                    <i class="bi bi-pencil-square text-warning"></i>
                                </button>
                                <button class="btn btn-sm"
                                    [ngClass]="{'colHide': element.IsMonthLocked == 1 || Filter.IsAutoReduction || this.Filter.AllocationType == 'O'}"
                                    name="delete" style="color: red;" (click)="deleteRow(i)"><i
                                        class="bi bi-trash-fill"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-7 px-1">
            </div>
            <div class="col-md-3 px-1">
                <label class="Label1">Total Alloted Manpower :-</label>
            </div>
            <div class="col px-1">
                <input name="totalallotedmanpoer" style="text-align: right;" type="number" class="form-control"
                    [(ngModel)]="this.Filter.TotalAllotedManpower" disabled />
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" *ngIf="(this.Filter.ESS_ShiftWiseManpowerMasterId == 0 && this.common.PageRight.IsAdd) || (this.Filter.ESS_ShiftWiseManpowerMasterId > 0 && this.common.PageRight.IsEdit)" class="btn btn-primary mx-1" name="save" (click)="save()"
                    [disabled]="(Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction) || this.Filter.AllocationType == 'O' || this.Filter.EditIndex != null">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
                <button type="button" class="btn btn-primary mx-1" name="back" (click)="Back()">
                    <i class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Back':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>